module.exports = __webpack_public_path__ + "img/arrow-narrow-right_1.f3547fe4.svg";